// Hook to fetch/put/post/delete the /applicationDetails response

/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useState } from 'react';

export const useFetchApplicationDetails = (shouldFetch, applicationId) => {
    const [applicationDetails, setApplicationDetails] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!shouldFetch) return () => {};

        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            if (!applicationId) {
                setLoading(false);
                return;
            }
            try {
                const response = await axios.get('/applicationDetails', {
                    cancelToken: source.token,
                    params: { id: applicationId }
                });
                if (!Response.hasData(response)) {
                    debug.e('Unable to get application details. No data.');
                } else {
                    setApplicationDetails(response?.data?.data?.details ?? {});
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    debug.e('Unable to get application details.', error);
                }
            }
            setLoading(false);
        };

        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [shouldFetch, applicationId]);

    return {
        applicationDetails,
        loading
    };
};
